import { render, staticRenderFns } from "./UsuarioRegister.vue?vue&type=template&id=3d14f292"
import script from "./UsuarioRegister.vue?vue&type=script&lang=js"
export * from "./UsuarioRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports